document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector("#cart-drawer");
  if (!cartDrawer) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "open") {
        if (cartDrawer.hasAttribute("open")) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
          }));
        }
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });
});
